import React from "react";
import { Card, CardBody, Container } from "reactstrap";
import { useNavigate } from "react-router-dom";

// Get embed URL based on environment
const getEmbedBaseUrl = () => {
  const env = process.env.REACT_APP_ENV;

  if (env === "production") {
    return "https://enrollment.baxrx.com";
  } else if (env === "development" || env === "testing") {
    return "https://baxrx-enrollment.netlify.app";
  }
  // Local development fallback
  return "http://localhost:3002";
};

const DrugSearch = () => {
  const navigate = useNavigate();
  const embedUrl = `${getEmbedBaseUrl()}/embed/search`;

  return (
    <div className="page-content px-0">
      <Container fluid>
        <Card>
          <CardBody>
            <div className="p-3 d-flex align-items-center justify-content-between">
              <div className="d-flex flex-column">
                <h3 className="fw-bold text-dark d-flex align-items-center">
                  <i
                    onClick={() => navigate("/profile")}
                    className="ri-arrow-left-s-line me-3 fs-3 cursor-pointer"
                  ></i>
                  Drug Search
                </h3>
              </div>
            </div>
            <div className="p-3">
              <iframe
                src={embedUrl}
                width="100%"
                height="700"
                frameBorder="0"
                title="Drug Search"
                style={{ border: "none", borderRadius: "8px" }}
              />
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default DrugSearch;
